/**
 * @namespace Global top namespace
 */
var revide = {};